<template>
  <div>
    <v-list-tile v-if="loading">
      <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
    </v-list-tile>
    <v-list-tile v-else avatar @click="openDialogUpdate()">
      <v-list-tile-avatar>
        <v-icon class="primary white--text">short_text</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title>{{ intent.code }} <!-- <span v-for="fa in intent.ex" :key="fa"> / {{ fa }} </span>--></v-list-tile-title>
        <v-list-tile-sub-title>{{ intent.desc }}</v-list-tile-sub-title>
      </v-list-tile-content>
      <v-list-tile-action>
        <v-menu bottom left>
          <v-btn icon="icon" slot="activator" @mouseover.native="overMenu = true" @mouseleave.native="overMenu = false">
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list dense>
            <v-list-tile @click="openDialogUpdate()">
              <v-list-tile-action>
                <v-icon>edit</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ $t('edit') | cap }} {{ $tc('Intent', 1) }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile @click="openDialogDeleteIntent(intent.code, intent.botWorkspace)">
              <v-list-tile-action>
                <v-icon>delete</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ $t('delete') | cap }} {{ $tc('Intent', 1) }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-list-tile-action>
    </v-list-tile>

    <v-dialog v-model="showDialogUpdate" max-width="490">
      <v-card>
        <v-card-title class="primary white--text">{{ $t('edit') | cap }} {{ $tc('Intention', 1) }} : {{intent.code}}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-text-field
            required
            :label="$t('intentCode')" 
            v-model="intentDialog.code"
            counter 
            max="32" >
          </v-text-field>
          <v-textarea 
            :label="$t('intentModifDesc')" 
            v-model="intentDialog.desc"
            :error="wzErrors.has('intentDialog')"
            :errors="wzErrors.collect('intentDialog')"
          ></v-textarea>

          <v-card-text > {{ $t('intentExamples') + '*' }}
             <v-fab-transition slot="activator">
             </v-fab-transition>
             <v-data-table
               :items="samples"
               hide-actions
             >
               <template slot="items" slot-scope="props">
                 <td>
                   <v-edit-dialog
                     :cancel-text="$t('cancel')"
                     :save-text="$t('submit')"
                     :return-value.sync="samples"
                     large
                     lazy
                   >
                     <div><code>{{ props.item.content }}</code></div>
                     <div slot="input" class="mt-3 title">{{ $t('editContent') }}</div>
                     <v-text-field
                       slot="input"
                       label="Modification"
                       v-model="props.item.content"
                       single-line
                       counter
                       autofocus
                     ></v-text-field>
                   </v-edit-dialog>
                 </td>
                 <td class="text-xs-right">
                   <v-btn icon flat @click.stop="openDialogDeleteSample(props.item)">
                     <v-icon>delete</v-icon>
                   </v-btn>
                 </td>
               </template>
             </v-data-table>
           </v-card-text>
           <v-btn
             class="secondary"
             dark
             bottom
             right
             @click.stop="addExample()"
           >
             <v-icon>add</v-icon>
           </v-btn>
          <small>*{{ $t('required') }}</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn flat @click="showDialogUpdate = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" :disabled="wzErrors.any()" @click="submitDialogUpdate">{{ $t('submitWatson') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDialogDeleteSample" max-width="490">
      <v-card>
        <v-card-title class="primary white--text">{{ $t('delete') | cap }} {{ $tc('intentExample', 1) }}</v-card-title>
        <v-card-text>
          {{ $t('delete') | cap }} {{ $tc('intentExample', 1) }} "{{ sampleToDelete.content }}"?
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn flat @click.native="showDialogDeleteSample = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" @click.native="submitDialogDelete">{{ $t('delete') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDialogDeleteIntent" max-width="490">
      <v-card>
        <v-card-title class="primary white--text">{{ $t('delete') | cap }} {{ $tc('Intention', 1) }}</v-card-title>
        <v-card-text>
          {{ $t('delete') | cap }} "{{ intentToDelete }}"?
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn flat @click.native="showDialogDeleteIntent = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" @click.native="submitDialogDeleteIntent">{{ $t('deleteWatson') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDialogCreate" max-width="290">
      <v-card>
        <v-card-title class="primary white--text">{{ $t('addSample') }}</v-card-title>
          <form>
            <v-text-field
              autofocus
              v-model="sampleToCreate"
              :label="$t('sentence')" 
              @keyup.native.enter="submitDialogCreate()"
            ></v-text-field>
          </form>
          <v-card-actions>
            <v-spacer/>
            <v-btn flat @click.native="showDialogCreate = false">{{ $t('cancel') }}</v-btn>
            <v-btn color="primary" @click.native="submitDialogCreate">{{ $t('add') }}</v-btn>
          </v-card-actions>
        </v-card-title>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import _ from 'lodash'

export default {

  props: {
    intent: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      /**
       * affiche/cache la fenetre de dialog de modification
       * @type {Boolean}
       */
      showDialogUpdate: false,
      /**
       * affiche/cache la fenetre de dialog de suppression
       * @type {Boolean}
       */
      showDialogDeleteSample: false,
      showDialogDeleteIntent: false,
      showDialogCreate: false,
      /**
       * phrase qui sera utilisée dans la fenêtre de dialogue de modification
       * @type {Object}
       */
      intentDialog: {},
      loading: false,
      overMenu: false,
      samples: [],
      sampleToDelete: {},
      intentToDelete: '',
      sampleToCreate: '',
      sampleOriginalName: '',
      botWorkspace: ''
    }
  },

  methods: {
    openDialogUpdate () {
      this.samples = []
      if (!this.overMenu) {
        this.intentDialog = _.clone(this.intent)
        this.sampleOriginalName = this.intentDialog.code
        this.botWorkspace = this.intentDialog.botWorkspace
        this.showDialogUpdate = true
        for (var n in this.intentDialog.ex) {
          this.samples.push({ content: this.intentDialog.ex[n], index: n })
        }
      }
    },
    openDialogDeleteSample (code) {
      this.showDialogCreateSample = false
      this.showDialogDeleteSample = true
      this.showDialogDeleteIntent = false
      this.sampleToDelete = code
    },
    openDialogDeleteIntent (code, botWorkspace) {
      this.showDialogCreateSample = false
      this.showDialogDeleteSample = false
      this.showDialogDeleteIntent = true
      this.intentToDelete = code
      this.botWorkspace = botWorkspace
    },
    submitDialogUpdate () {
      this.showDialogUpdate = false

      let dataToPost = new window.FormData()
      dataToPost.append('code', this.intentDialog.code)
      dataToPost.append('origin', this.sampleOriginalName)
      dataToPost.append('desc', this.intentDialog.desc)
      dataToPost.append('samples', JSON.stringify(this.samples))
      dataToPost.append('botWorkspace', this.botWorkspace)
      this.loading = true

      this.axios.post('https://public.targetfirst.com/public/ibm/edit_intent.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      /* this.axios.post('put/intent.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}) */
      .then(response => {
        // Notification
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifSuccess'), context: 'success' })
        this.$store.commit('_User/RELOAD_WATSON', {
          editWatson: Math.random()
        })
      })
      .catch(_ => {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifFailure'), context: 'error' })
      })
      .then(_ => {
        this.loading = false
      })
    },

    submitDialogDelete () {
      this.showDialogDeleteSample = false
      if (this.sampleToDelete !== '') {
        this.samples.splice(this.sampleToDelete.index, 1)
        this.sampleToDelete = {}
      }
    },
    submitDialogDeleteIntent () {
      this.showDialogDeleteIntent = false
      if (this.intentToDelete !== '') {
        let intentToSayTodelete = this.intentToDelete
        let dataToPost = new window.FormData()
        dataToPost.append('code', this.intentToDelete)
        dataToPost.append('botWorkspace', this.botWorkspace)
        this.loading = true

        this.axios.post('https://public.targetfirst.com/public/ibm/delete_intent.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        /* this.axios.post('put/intent.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}) */
        .then(response => {
          // Notification
          this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifSuccess'), context: 'success' })
          this.$store.commit('_User/RELOAD_WATSON', {
            editWatson: Math.random()
          })
          this.$emit('removeIntent', intentToSayTodelete)
        })
        .catch(_ => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifFailure'), context: 'error' })
        })
        .then(_ => {
          this.loading = false
        })
        this.intentToDelete = ''
      }
    },
    submitDialogCreate () {
      this.showDialogCreate = false
      if (this.sampleToCreate !== '') {
        for (let s in this.samples) {
          console.log(this.samples[s])
          if (this.samples[s].content === this.sampleToCreate) {
            alert('Exemple déjà existant')
            return
          }
        }
        this.samples.push({content: this.sampleToCreate, index: this.samples.length})
        this.sampleToCreate = {}
      }
    },
    addExample () {
      this.showDialogDeleteSample = false
      this.showDialogDeleteIntent = false
      this.showDialogCreate = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheezy/WzIntent.vue